import { useMutation, useQueryClient } from 'react-query';

import { addOwnerToClient as update } from 'api/clients/addOwnerToClient';

const useAddOwnerToClient = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: AddOwnerToClient,
    isLoading,
  } = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries('clients');
    },
  });

  return {
    isSuccess,
    AddOwnerToClient,
    isLoading,
  };
};

export default useAddOwnerToClient;
